export default {
  pickingLists: [],
  pickingList: undefined,
};
